import { CcRequirementPriority } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setCcRequirementPriorityList = (priorityList: types.CcRequirementPriorityList) => ({
    type: inferLiteral(types.CC_REQUIREMENT_PRIORITY_LIST),
    priorityList,
})
export const setCcRequirementPriorityIds = (priorityIds: readonly number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_PRIORITY_IDS),
    priorityIds,
})
export const setCcRequirementPriorityEdit = (priority: CcRequirementPriority) => ({
    type: inferLiteral(types.CC_REQUIREMENT_PRIORITY_EDIT),
    priority,
})
export const setCcRequirementPriorityReloadList = (value: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_PRIORITY_RELOAD_LIST),
    value,
})
export const setCcRequirementPriorityReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_PRIORITY_RELOAD_EDIT),
    value,
})
